export const introduce = {
  text: `### 指标原理
  + 处于亏损状态的代币供应量`,
  height: 1290,
};